import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import * as fromStore from '../../store';

@Component({
  selector: 'app-contact-admin',
  template: `
    <div class="w-full max-w-7xl items-center">
      <section class="mt- mb-8 flex lg:mb-0">
        <div
          class="w-full max-w-xl rounded-xl bg-white p-8 text-black shadow-lg md:p-10"
        >
          <!-- Comcast Business | Nitel Logo -->
          <div class="flex items-center justify-center">
            <a routerLink="/" class="inline-block" title="Go to homepage">
              <img
                src="assets/images/logos/comcast_bussiness_nitel_logo.png"
                alt="Comcast Business | Nitel Logo"
                class="h-24 w-auto lg:h-28"
              />
            </a>
          </div>
          <h2
            class="mt-4 font-montserrat text-2xl font-bold text-black lg:text-3xl"
          >
            Unauthorized Access
          </h2>
          <div class="mt-4 flex">
            <p class="text-lg">
              You currently do not have access permissions in MyPortal. Please
              reach out to your
              {{
                (loggedInUser$ | async)?.SuperAdmins?.length
                  ? 'administrator'
                  : 'account manager'
              }}

              for assistance:
            </p>

            @if (!(loggedInUser$ | async)?.SuperAdmins?.length) {
              <div class="my-4 flex font-lato text-base">
                <p>
                  {{
                    (loggedInUser$ | async)?.Account?.Account_Manager__r
                      ?.Name || 'N/A'
                  }}
                </p>
                <p>
                  <strong>Phone:</strong>
                  {{
                    (loggedInUser$ | async)?.Account?.Account_Manager__r
                      ?.Phone || 'N/A'
                  }}
                </p>
                <p>
                  <strong>Email:</strong>
                  <a
                    [href]="
                      'mailto:' +
                      ((loggedInUser$ | async)?.Account?.Account_Manager__r
                        ?.Email || '')
                    "
                  >
                    {{
                      (loggedInUser$ | async)?.Account?.Account_Manager__r
                        ?.Email || 'N/A'
                    }}
                  </a>
                </p>
              </div>
            } @else {
              <div class="my-4 flex font-lato text-base">
                @for (
                  admin of (loggedInUser$ | async)?.SuperAdmins;
                  track admin?.Name
                ) {
                  <p>
                    {{ admin?.Name || 'N/A' }}
                  </p>
                  <p>
                    <strong>Phone:</strong>
                    {{ admin?.Phone || 'N/A' }}
                  </p>
                  <p>
                    <strong>Email:</strong>
                    <a [href]="'mailto:' + (admin?.Email || '')">
                      {{ admin?.Email || 'N/A' }}
                    </a>
                  </p>
                }
              </div>
            }
          </div>
        </div>
      </section>
    </div>
  `,
  standalone: false,
})
export class AccessDeniedComponent implements OnInit {
  private store = inject(Store<fromStore.State>);

  loggedInUser$ = this.store.select(fromStore.getCurrentUser);

  ngOnInit(): void {
    this.store
      .select(fromStore.getCurrentUserLoaded)
      .pipe(take(1))
      .subscribe((loaded) => {
        if (!loaded) {
          this.store.dispatch(new fromStore.LoadCurrentUser());
        }
      });
  }
}
